import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Estudantes',
    path: '/academico/estudante',
    name: 'estudante',
    component: () => import('@/views/academico/estudante/cadastro/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.DADOSDOESTUDANTE_MENU_300100202],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Estudante',
    path: '/academico/estudante/cadastro',
    parent: 'estudante',
    name: 'cadastroestudante',
    component: () => import('@/views/academico/estudante/cadastro/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.DADOSDOESTUDANTE_MENU_300100202],
    },
  },
  {
    description: 'Edição de Estudante',
    path: '/academico/estudante/editar/:id',
    parent: 'estudante',
    name: 'editarestudante',
    component: () => import('@/views/academico/estudante/cadastro/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.DADOSDOESTUDANTE_MENU_300100202],
      params: {},
    },
  },
  {
    description: 'Responsáveis do Estudante',
    path: '/academico/estudante/:id/responsavel',
    parent: 'estudante',
    name: 'responsavelestudante',
    component: () => import('@/views/academico/estudante/responsavel/cadastro/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.DADOSDOESTUDANTE_MENU_300100202],
    },
  },
  {
    description: 'Edição de Responsável',
    path: '/academico/estudante/:id/responsavel/:responsavelid',
    parent: 'responsavelestudante',
    name: 'editarresponsavel',
    component: () => import('@/views/academico/estudante/responsavel/cadastro/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.DADOSDOESTUDANTE_MENU_300100202],
    },
  },
  {
    description: 'Cadastro de Responsável',
    path: '/academico/estudante/:id/responsavel/cadastro',
    parent: 'responsavelestudante',
    name: 'cadastroresponsavel',
    component: () => import('@/views/academico/estudante/responsavel/cadastro/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.DADOSDOESTUDANTE_MENU_300100202],
    },
  },
  {
    description: 'Painel do Estudante',
    path: '/academico/estudante/painelestudante',
    name: 'painel_estudante',
    component: () => import('@/views/academico/estudante/painelestudante/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.PAINELDOESTUDANTENOVO_MENU_300100050],
    },
  },
];
